import { render, staticRenderFns } from "./AddAttendeeComponent.vue?vue&type=template&id=51a67575&scoped=true"
import script from "./AddAttendeeComponent.vue?vue&type=script&lang=js"
export * from "./AddAttendeeComponent.vue?vue&type=script&lang=js"
import style0 from "./AddAttendeeComponent.vue?vue&type=style&index=0&id=51a67575&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a67575",
  null
  
)

export default component.exports